export default class AffiliateViewDataModel{
    user_id: number;
    logo: string;
    tagline: string;
    search_result_questions: {
        short_connections: number,
        airport_changes: number,
        baggage_recheck: number
    };
    data_collection_questions: Array<any>;
    //urls: Array<any>;
    timestamp: number;
}